module.exports = __webpack_public_path__ + "img/bg.285af82f.png";